<template>
  <labeled-form-control label="Address">
    <span v-if="loading" class="inline-loader"></span>
    <div v-else>
      <div :style="{ display: canUseLookup && !isManualInput ? 'block' : 'none' }">
        <address-lookup v-model="addressLookupInputStatus" @addressClicked="handleAddressClick"/>
        <a @click="isManualInput = true" class="link" style="cursor: pointer !important">
          <i class="fa fa-pencil-alt mr-1"></i>
          Enter address manually
        </a>
      </div>
      <div :style="{ display: isManualInput ? 'block' : 'none' }">
        <address-manual-input v-model="addressManualInputStatus" />
        <a @click="isManualInput = false" class="link" :style="{ display: canUseLookup ? 'inline' : 'none', cursor: 'pointer !important' }">
          <i class="fa fa-search mr-1"></i>
          Search by postcode
        </a>
      </div>
    </div>
  </labeled-form-control>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { FormatCountryCacheMixin } from '@/mixins/Booking/FormatCountryCacheMixin'
import { SubscriptionCacheMixin } from '@/mixins/Booking/SubscriptionCacheMixin'
import { StatusEmitterMixin } from '@/mixins/GeneralRegistration/StatusEmitterMixin'
import LabeledFormControl from '@/components/Layout/LabeledFormControl.vue'
import ClientAddressFieldManualInput from './ClientAddressFieldManualInput.vue'
import ClientAddressFieldLookup from './ClientAddressFieldLookup.vue'

export default {
  name: 'ClientAddressField',
  mixins: [FormatCountryCacheMixin, SubscriptionCacheMixin, StatusEmitterMixin],
  data () {
    return {
      isManualInput: false,
      addressManualInputStatus: {},
      addressLookupInputStatus: {}
    }
  },
  computed: {
    ...mapState('ApplicationEvents', [
      'saveClientRegistrationEvent'
    ]),
    loading () {
      return !!this.loadingCountryFormat || !!this.fetchingCountries
    },
    canUseLookup () {
      return !!(this.countryFormat && this.countryFormat.addressLookup && this.postcodeLookupAllowed)
    },
    validated () {
      return !!this.addressLookupInputStatus.validated || !!this.addressManualInputStatus.validated
    }
  },
  watch: {
    attemptedCountries (value) {
      if (value && !this.country) {
        this.isManualInput = true
      }
    },
    saveClientRegistrationEvent () {
      this.isManualInput = true
    }
  },
  methods: {
    ...mapMutations('ClientRegistrationUpload', [
      'setClientAddressLines'
    ]),
    handleAddressClick (value) {
      this.setClientAddressLines(value)
      this.isManualInput = true
    }
  },
  components: {
    'labeled-form-control': LabeledFormControl,
    'address-manual-input': ClientAddressFieldManualInput,
    'address-lookup': ClientAddressFieldLookup
  }
}
</script>
